<div class="analytics-page-component">
  @if (showDashboard) {
    <div class="dashboard">
      <kehe-phoenix-manage-list-page-title-layout
        pageTitle="Gap & Void Dashboard"
      >
        <ng-template #actionsBlock>
          <!-- Help Button + Modal -->
          <kehe-phoenix-help-button-modal-block
            [videos]="helpVideos"
            [faqs]="faqs"
          ></kehe-phoenix-help-button-modal-block>
        </ng-template>
      </kehe-phoenix-manage-list-page-title-layout>
      <app-report
        [url]="dashboardUrl"
        [token]="userToken$ | async"
        [height]="dashboardHeight"
      >
      </app-report>
      <div class="report-link">
        <a routerLink="/reporting" routerLinkActive="active"
          >Gap Void Sales Report/Export Version</a
        >
      </div>
    </div>
  }

  @if (!showDashboard) {
    <app-unauthorized-page></app-unauthorized-page>
  }
</div>
